import React from 'react';
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import HelpCard from './HelpCard/HelpCard'
const Help = () => {
  return (
    <div>
      <Header />
              <HelpCard />                             
      <Footer />
    </div>
  )
}

export default Help
